import React, { useState, useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';

const ProjectsOverview = () => {
    const [data, setData] = useState({ totalProjects: 0, activeProjects: 0 });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const apiClient = new APIClient();
            const response: any = await apiClient.get('/dashboard/projects-overview');
            if (response?.data) {
                setData({
                    totalProjects: response.data.totalProjects ?? 0,
                    activeProjects: response.data.activeProjects ?? 0,
                });
            }
        } catch (error) {
            console.error('Error fetching projects overview:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card className="card-animate h-100">
            <CardBody>
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                        <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Projects</p>
                    </div>
                    <div className="flex-shrink-0">
                        <div className="avatar-sm rounded">
                            <div className="avatar-title bg-primary-subtle text-primary fs-20 rounded">
                                <i className="ri-folder-line"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                        <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                            <span className="counter-value">{loading ? '...' : data.totalProjects}</span>
                        </h4>
                        <span className="badge bg-success-subtle text-success mb-0">
                            <i className="ri-checkbox-circle-line align-middle"></i>{' '}
                            {loading ? '...' : data.activeProjects} active
                        </span>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default ProjectsOverview;
